/**
 * フロント側で使用するメールアドレス形式チェック。
 */
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;

export const isValidEmail = (email: string): boolean => EMAIL_REGEXP.test(email);
